import React, { useEffect, useState } from 'react';
import { Container, Row,Card } from "react-bootstrap";
import { Button, Select, Flex, message, Modal,Table,Input } from 'antd';
import  UseApiService  from './../../services/Api.service'
import * as constants from './../../constants/constants'

import { PlusOutlined,EyeOutlined,UserOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Search } = Input;

export default function CustomersPage(){
  const [loading,setLoading] = useState(false);  
  const [selectedRowKey, setSelectedRowKey] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [searchValue,setSearchValue] = useState();  
  const [filteredData, setFilteredData] = useState([]);
  const [data,setData] = useState();
  const [rowSelected,setRowSelected]= useState(null);
  const [experiencieSelected,setExperienceSelected]= useState(null);
  //const [columns,setColumnns] = useState();
  const [wizardVisible, setWizardVisible] = useState(false);
  
  const navigate = useNavigate();

  const columns = [    
    {
      title: 'Id',
      dataIndex: 'uid',
      width:120,
      render:(text) =>(
        <span className="">{text}</span>
      )
    },
    {
      title: 'Tipo',
      dataIndex: 'Type',
      width:50,
      render:(text) =>(
        <span className="">{text}</span>
      )
    },
    {
      title: 'Creado',
      dataIndex: 'date',
      width:40,
      render:(text) =>(
        <span className="">{text.substring(0,10)}</span>
      )
    },
    {
      title: 'Última visita',
      dataIndex: 'lastvisit',
      width:40,
      render:(text) =>(
        <span className="">{text.substring(0,10)}</span>
      )
    },
    {
      title: 'Vistas',
      dataIndex: 'pageviews',
      width:50,
      align:'right',
      render:(text) =>(
        <span className="">{text}</span>
      )
    },
    {
      title: 'Email',
      dataIndex: 'email',
      width:70,
      render:(text) =>(
        <span className="">{text}</span>
      )
    },
    {
      title: '',
      dataIndex: 'key',      
      width:30,
      render:(text,record) =>(
        <>
          <Button color="default" variant="outlined" onClick={()=>handleUrl(record.uid)}>
            <EyeOutlined />
          </Button>
        </>
      )
    }    
  ];

  const handleUrl = (ppid) =>{
    navigate('/dashboard/usuarios/'+ppid);
  }

  useEffect(()=>{
    const url = constants.API_USUARIOS;
    //const url = constants.U_API2+'?opt=usrs';

    setLoading(true);
    UseApiService(url,{method:'GET'})
    .then(({data,error}) =>{
      if(error){
        message.warning('Ocurrio un error: '.error);
      }
      else{
        setData(data.Usuarios);
      }
    })
    .catch((e)=>{
      console.log(e);
      message.warning('Ocurrio un error:'.e);
    })
    .finally((e)=>{
      setLoading(false);
    });    
   //setData(dataJson)
  },[])

  useEffect(()=>{
    setFilteredData(data);
  },[data])

  const handleChange = (value) => {
    setExperienceSelected(value);
  };

  const onSearch = (value) => {
    setLoading(true);
    setSearchValue(value);
    if (value) {
      const filtered = data.filter(item =>
        item.audiencia.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredData(filtered);
    } else {
      setFilteredData(data);     
    }
    setLoading(false);
  };

  const showModal = (row) => {
    setExperienceSelected('Seleccionar');
    setRowSelected(row)
    setIsModalOpen(true);
  };

  const handleOk = () => {
    message.info('Aplicando '+experiencieSelected + ' en ' + rowSelected.audiencia);
    setIsModalOpen(false);    
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleCreateNew = () => {    
    setWizardVisible(true)
  }

  const handleRowClick = (record) => {
    setSelectedRowKey(record.uid);
  };
  
  const rowClassName = (record) => {
    return record.uid === selectedRowKey ? 'selected-row' : '';
  };

  return(
    <>
      <Container className="content">
        <Row>
          <span className='h3 mt-1 text-black'><UserOutlined /> Usuarios</span>
        </Row>
        <Row className='mt-3'>
          <Card border='light'>
            <Card.Body>        
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>          
                <Search
                  placeholder="Busca usuario"
                  /*onSearch={handelSearch}*/
                  enterButton
                  style={{ width: 280 }}
                  loading={loading}
                />                
              </div>
            </Card.Body>
          </Card>
        </Row>
        <Row>
          <Card className="mt-4" border='light'>
            <Card.Body>
              <Table 
                columns={columns}
                dataSource={data}
                rowKey='uid'
                rowClassName={rowClassName}
                loading={loading}
                onRow={(record) => ({
                  onClick: () => handleRowClick(record), 
                })}
                size="small"
                scroll={{ x: 'max-content', y: 450 }}
                //pagination={{ pageSize: 10 }}
              />
            </Card.Body>
          </Card>      
        </Row>
      </Container>      
    </>
  )
}